import React, { useState, Fragment } from 'react'
import { Dialog, Listbox, Transition } from "@headlessui/react";
import { HiChevronUpDown } from 'react-icons/hi2';

const Currency = [
    { id: 1, name: "USD - US Dollar" },
    { id: 2, name: "INR - Indian Rupee" },
    { id: 3, name: "AFN - Afghan Afghani" },
    { id: 4, name: "AOA - Angolan Kwanza" },
    { id: 5, name: "BAM - Bosnia-Herzegovina Convertible Mark" },
    { id: 6, name: "BIF - Burundian Franc" },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const ItemOptionsModal = ({ openItem, setOpenItem }) => {
    const [addCurrency, setAddCurrency] = useState(Currency[0]);

    return (
        <div>
            <Transition.Root show={openItem} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenItem}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3] transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-[496px]">
                                    <div>
                                        <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">Items Options</div>
                                        <div className="p-[16px_20px] border-b-[1px] border-[#ebeef1]">
                                            <span className="text-sm text-[#414552] font-medium">
                                                Currency
                                            </span>
                                            <Listbox
                                                value={addCurrency}
                                                onChange={setAddCurrency}
                                            >
                                                {({ open }) => (
                                                    <>
                                                        <div className="relative mt-1">
                                                            <Listbox.Button className="relative w-full rounded-md bg-white py-1 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 font-medium ring-inset ring-gray-300 focus:outline-none text-sm leading-6">
                                                                <span className="block truncate">
                                                                    {addCurrency.name}
                                                                </span>
                                                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                                    <HiChevronUpDown className="text-[20px]" />
                                                                </span>
                                                            </Listbox.Button>

                                                            <Transition
                                                                show={open}
                                                                as={Fragment}
                                                                leave="transition ease-in duration-100"
                                                                leaveFrom="opacity-100"
                                                                leaveTo="opacity-0"
                                                            >
                                                                <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 shadow-xl focus:outline-none text-sm">
                                                                    {Currency.map((person) => (
                                                                        <Listbox.Option
                                                                            key={person.id}
                                                                            className={({ active }) =>
                                                                                classNames(
                                                                                    active
                                                                                        ? "bg-[#f6f8fa]"
                                                                                        : "text-[#414552]",
                                                                                    "relative cursor-default select-none py-2 pl-3 pr-9"
                                                                                )
                                                                            }
                                                                            value={person}
                                                                        >
                                                                            {({ addCurrency, active }) => (
                                                                                <>
                                                                                    <span
                                                                                        className={classNames(
                                                                                            addCurrency
                                                                                                ? "font-semibold"
                                                                                                : "font-normal",
                                                                                            "block truncate"
                                                                                        )}
                                                                                    >
                                                                                        {person.name}
                                                                                    </span>

                                                                                    {addCurrency ? (
                                                                                        <span
                                                                                            className={classNames(
                                                                                                active
                                                                                                    ? "text-white"
                                                                                                    : "text-indigo-600",
                                                                                                "absolute inset-y-0 right-0 flex items-center pr-4"
                                                                                            )}
                                                                                        ></span>
                                                                                    ) : null}
                                                                                </>
                                                                            )}
                                                                        </Listbox.Option>
                                                                    ))}
                                                                </Listbox.Options>
                                                            </Transition>
                                                        </div>
                                                    </>
                                                )}
                                            </Listbox>
                                            <div className='mt-5'>
                                                <div className="flex justify-between text-[#404152] mt-2">
                                                    <div className="relative flex items-center">
                                                        <div className="flex items-center">
                                                            <input id="option-1" name="item-option" type="checkbox" className="h-[15px] w-[15px] rounded border-gray-300 accent-[#625afa] focus:outline-none" />
                                                        </div>
                                                        <div className="ml-2 text-sm translate-y-[1px]">
                                                            <label htmlFor="option-1" className="select-none font-semibold cursor-pointer">Display tax-exclusive prices</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p className='text-xs mt-1 text-[#687385] font-normal pl-[23px]'>You can show prices that include or exclude taxes and configure your <span className='text-[#625afa] font-semibold cursor-pointer'>tax rates</span> accordingly. Some EU countries require prices to be displayed exclusive of taxes. <span className='text-[#625afa] font-semibold cursor-pointer'>Learn more</span></p>
                                            </div>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]" onClick={() => setOpenItem(false)}>Cancel</button>
                                            <button className="h-[30px] rounded-[6px] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Update</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default ItemOptionsModal